import React from 'react'
import AdminDashboard from '../../../Compnents/Admin/AdminDashboard'

const AdminDasboardScreen = () => {
    return (
        <AdminDashboard />
    )
}

export default AdminDasboardScreen